/* Page Formations : fenêtre « Voir plus » (une par carte, rendue dans la carte) et carrousel de photos. Pas de lecture automatique. */
(() => {
  if (window.__miFormationsInit) return;
  window.__miFormationsInit = true;

  const root = document.documentElement;
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let current = null;
  let opener = null;
  let timer = 0;

  function open(id, trigger) {
    const modal = document.getElementById(id);
    if (!modal) return;
    if (current) hideNow(current);
    opener = trigger || document.activeElement;
    clearTimeout(timer);
    /* La fenêtre sort de la carte (transform/animation) : on la place sous <body> pour que position: fixed couvre l'écran. */
    if (modal.parentElement !== document.body) { modal.__home = modal.parentElement; document.body.appendChild(modal); }
    modal.hidden = false;
    root.classList.add('fm-lock');
    void modal.offsetWidth;
    modal.classList.add('is-open');
    current = modal;
    const track = modal.querySelector('[data-fm-track]');
    if (track) { track.scrollLeft = 0; sync(modal.querySelector('[data-fm-car]')); }
    const x = modal.querySelector('.fm-modal__x');
    (x || modal.querySelector('.fm-modal__dialog')).focus({ preventScroll: true });
  }
  function hideNow(modal) {
    modal.classList.remove('is-open');
    modal.hidden = true;
    if (modal.__home) { modal.__home.appendChild(modal); modal.__home = null; }
    root.classList.remove('fm-lock');
  }
  function close() {
    if (!current) return;
    const modal = current;
    current = null;
    modal.classList.remove('is-open');
    const done = () => hideNow(modal);
    if (reduce()) done(); else timer = setTimeout(done, 320);
    if (opener && opener.isConnected && opener.focus) opener.focus({ preventScroll: true });
    opener = null;
  }

  /* Carrousel (sur la carte et dans la fenêtre) */
  function slides(car) { return car.querySelectorAll('.fm-car__slide'); }
  function index(car) {
    const track = car.querySelector('[data-fm-track]');
    if (!track || !track.clientWidth) return 0;
    return Math.round(track.scrollLeft / track.clientWidth);
  }
  function sync(car) {
    if (!car) return;
    const n = slides(car).length;
    const i = Math.min(index(car), Math.max(n - 1, 0));
    car.querySelectorAll('.fm-car__dot').forEach((d, k) => d.classList.toggle('is-on', k === i));
    const prev = car.querySelector('[data-fm-prev]');
    const next = car.querySelector('[data-fm-next]');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= n - 1;
  }
  function go(car, delta) {
    const track = car && car.querySelector('[data-fm-track]');
    if (!track) return;
    const n = slides(car).length;
    const to = Math.max(0, Math.min(n - 1, index(car) + delta));
    track.scrollTo({ left: to * track.clientWidth, behavior: reduce() ? 'auto' : 'smooth' });
  }

  document.addEventListener('click', (e) => {
    const nav = e.target.closest && e.target.closest('[data-fm-prev], [data-fm-next]');
    if (nav) { e.preventDefault(); go(nav.closest('[data-fm-car]'), nav.hasAttribute('data-fm-prev') ? -1 : 1); return; }
    const t = e.target.closest && e.target.closest('[data-fm-open]');
    if (t) { e.preventDefault(); open(t.getAttribute('data-fm-open'), t); return; }
    if (!current) return;
    if (e.target.closest('[data-fm-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('scroll', (e) => {
    if (e.target.matches && e.target.matches('[data-fm-track]')) sync(e.target.closest('[data-fm-car]'));
  }, true);

  document.addEventListener('keydown', (e) => {
    if (!current) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'ArrowLeft' && current.querySelector('[data-fm-track]')) { e.preventDefault(); go(current.querySelector('[data-fm-car]'), -1); return; }
    if (e.key === 'ArrowRight' && current.querySelector('[data-fm-track]')) { e.preventDefault(); go(current.querySelector('[data-fm-car]'), 1); return; }
    if (e.key === 'Tab') {
      const f = [...current.querySelectorAll(FOCUSABLE)].filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === current.querySelector('.fm-modal__dialog'))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  const syncAll = () => document.querySelectorAll('[data-fm-car]').forEach(sync);
  window.addEventListener('resize', syncAll);
  syncAll();
})();
